import React, { Component } from 'react'
import './Icons.css'
import {GrLinkedin, GrGithub, GrMail} from 'react-icons/gr'

class Icons extends Component {
    render() {
        return (
        <div className="icons">
            <button className="iconButton" type="button" onClick={(e) => { e.preventDefault(); window.open('https://www.linkedin.com/in/war-revend-115700159/', "_blank");}}>          
                <GrLinkedin className="icon"/>
            </button>
            <button className="iconButton" type="button" onClick={(e) => { e.preventDefault(); window.open('https://github.com/wargold', "_blank");}}>          
                <GrGithub className="icon"/>
            </button>
            <button className="iconButton" type="button" onClick={(e) => { e.preventDefault(); window.location.href='mailto:war.revend@gmail.com';}}>          
                <GrMail className="icon"/>
            </button>
        </div>
        )
    }
}
export default Icons;